import React, { useEffect, useState } from 'react';
import { shippingApi } from '../api/shippingRate';
import { selectedCurrencyState } from '../store/selectedCurrencyAtom';
import { useRecoilValue } from 'recoil';
import { currencySigns } from '../utils/currencies';
import { Truck } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { getCachedUserLocation } from '../utils/userLocation';

const ShippingCost = ({ packageDetails, onShippingCalculated }) => {
    const { t } = useTranslation();

    const shippingIconSize = 20;
    
    const [location, setUserLocation] = useState(null);

    const [shippingCost, setShippingCost] = useState(null);
    const [shippingCurrency, setShippingCurrency] = useState(null);

    const [error, setError] = useState(null);

    const selectedCurrency = useRecoilValue(selectedCurrencyState); // Get selected currency

    useEffect(() => {
        const calculateShippingCost = async () => {

            try {
                const location = await getCachedUserLocation()
                setUserLocation(location)
                if (!location || !location.countryCode) {
                    setError('Unable to determine location.');
                    return;
                }

                const rateRequest = {
                    receiver: {
                        postal_code: location.zipCode || '',
                        city: location.cityName || '',
                        country_code: location.countryCode,
                    },
                    package: packageDetails,
                    currency: selectedCurrency
                };

                const response = await shippingApi.getRate(rateRequest);
                setShippingCost(response.price); // Store price in EUR
                setShippingCurrency(response.price_currency);
                
                if (onShippingCalculated) {
                    onShippingCalculated({
                        price: response.price,
                        currency: response.price_currency,
                        countryCode: location.countryCode,
                    });
                }
            } catch (err) {
                console.error('Error fetching shipping cost:', err);
                setError(true);
            }
        };

        calculateShippingCost();
    }, [packageDetails, selectedCurrency]);

    // If an error occurs, render nothing
    if (error) {
        return null;
    }

    if (shippingCost === null) {
        return (
            <div className="flex items-center gap-2 text-gray-500" style={{ opacity: 0.8 }}>
                <Truck size={shippingIconSize}/> {/* Shipping icon */}
                <p>{t("Calculating shipping cost...")}</p>
            </div>
        );
    }

    return (
        <>
            <div className="text-gray-500" style={{ opacity: 0.8 }}>
                <div className='flex items-center gap-1'>
                    {/* <Truck size={shippingIconSize}/> */}
                    {t("Shipping to ")} <p>{" "}{location.countryName}</p>
                </div>
                <div>
                    <p className="font-medium text-lg text-black">
                        {currencySigns[shippingCurrency] || shippingCurrency}{" "}
                        {shippingCost.toFixed(2)}
                    </p>
                </div>
                <p>
                    {t("Dispatches from Slovenia within")}
                </p>
                <p className="font-medium text-lg text-black mb-4">
                        3 {t("days")}
                </p>
                <p className='text-sm'>
                    {t("Allow up to two weeks for international delivery")}
                </p>
            </div>
            <div className="flex items-center text-gray-500" style={{ opacity: 0.8 }}>
                
            </div>
        </>
        
    );
};

export default ShippingCost;